import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'link' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  onClick,
  type = 'button',
  icon,
  iconPosition = 'left',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#B61C1C] relative overflow-hidden';
  const variantStyles = {
    primary: 'bg-[#B61C1C] text-white hover:bg-[#961818] border border-transparent shadow-sm active:translate-y-0.5 active:shadow-none',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200 border border-transparent shadow-sm active:translate-y-0.5 active:shadow-none',
    outline: 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 shadow-sm active:translate-y-0.5 active:shadow-none',
    ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 border border-transparent active:bg-gray-200',
    link: 'bg-transparent text-[#B61C1C] hover:underline border border-transparent p-0 shadow-none active:text-[#961818]',
    danger: 'bg-red-600 text-white hover:bg-red-700 border border-transparent shadow-sm active:translate-y-0.5 active:shadow-none'
  };
  const sizeStyles = {
    sm: 'text-xs px-2.5 py-1.5 rounded-md',
    md: 'text-sm px-4 py-2 rounded-md',
    lg: 'text-base px-6 py-3 rounded-md'
  };
  const disabledStyles = disabled ? 'opacity-60 cursor-not-allowed pointer-events-none' : 'cursor-pointer';
  const widthStyles = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${disabledStyles} ${widthStyles} ${className}`} disabled={disabled} onClick={onClick} type={type} {...props} data-id="element-3694">
      {icon && iconPosition === 'left' && <span className={`mr-2 ${size === 'sm' ? 'text-xs' : size === 'lg' ? 'text-base' : 'text-sm'}`} data-id="element-3695">
          {icon}
        </span>}
      {children}
      {icon && iconPosition === 'right' && <span className={`ml-2 ${size === 'sm' ? 'text-xs' : size === 'lg' ? 'text-base' : 'text-sm'}`} data-id="element-3696">
          {icon}
        </span>}
      <span className="absolute inset-0 overflow-hidden rounded-md pointer-events-none" aria-hidden="true" data-id="element-3697">
        <span className="absolute inset-0 rounded-md bg-white/10 opacity-0 hover:opacity-100 transition-opacity duration-200" data-id="element-3698"></span>
      </span>
    </button>;
}